import React from 'react';

import { Panel, Item, Headding } from 'src/components/PrimaryPanel';
import BasicInfoSectionShow from 'src/features/Employees/components/BasicInfoSectionShow';
import BusinessInfoSectionShow from 'src/features/Employees/components/BusinessInfoSectionShow';
import { useTranslation } from 'react-i18next';

const SimpleProfileShow = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Panel>
        <Headding>{t('features.Users.components.SimpleProfileShow.basic_information')}</Headding>
        <Item>
          <BasicInfoSectionShow />
        </Item>
      </Panel>

      <Panel>
        <Headding>{t('features.Users.components.SimpleProfileShow.business_information')}</Headding>
        <Item>
          <BusinessInfoSectionShow />
        </Item>
      </Panel>
    </div>
  );
};

export default SimpleProfileShow;
